import { usePageHeader } from "@/components/layouts/lib/page-header";
import { INVOICES_PAGE_GUIDE } from "./invoices/invoice.constants";
import { InvoiceQuickViewDialog } from "./invoices/components/InvoiceQuickViewDialog";
import { InvoiceFilteredTotals } from "./invoices/components/InvoiceFilteredTotals";
import { InvoiceStatsGrid } from "./invoices/components/InvoiceStatsGrid";
import { InvoicesContent } from "./invoices/components/InvoicesContent";
import { InvoicesPageIntro } from "./invoices/components/InvoicesPageIntro";
import { InvoicesToolbar } from "./invoices/components/InvoicesToolbar";
import { useInvoicesPageData } from "./invoices/hooks/useInvoicesPageData";
import { useInvoicesPageState } from "./invoices/hooks/useInvoicesPageState";

export default function InvoicesPage() {
  usePageHeader({
    title: "Factures",
    helpTopic: "documents",
    guide: {
      steps: INVOICES_PAGE_GUIDE,
    },
  });

  const pageState = useInvoicesPageState();
  const pageData = useInvoicesPageData({
    search: pageState.search,
    statusFilter: pageState.statusFilter,
    paymentFilter: pageState.paymentFilter,
  });

  return (
    <div>
      <InvoicesPageIntro />
      <InvoiceStatsGrid
        invoicesCount={pageData.invoices.length}
        metrics={pageData.metrics}
        latest={pageData.latest}
        loading={pageData.isLoading}
      />
      <InvoicesToolbar
        search={pageState.search}
        statusFilter={pageState.statusFilter}
        paymentFilter={pageState.paymentFilter}
        viewMode={pageState.viewMode}
        filteredCount={pageData.filteredInvoices.length}
        totalCount={pageData.invoices.length}
        onSearchChange={pageState.setSearch}
        onStatusFilterChange={pageState.setStatusFilter}
        onPaymentFilterChange={pageState.setPaymentFilter}
        onViewModeChange={pageState.setViewMode}
        onResetFilters={pageState.resetFilters}
      />
      <InvoiceFilteredTotals totals={pageData.filteredTotals} loading={pageData.isLoading} />
      <InvoicesContent
        invoices={pageData.filteredInvoices}
        viewMode={pageState.viewMode}
        isLoading={pageData.isLoading}
        onSelect={pageState.setSelectedInvoice}
      />
      <InvoiceQuickViewDialog
        invoice={pageState.selectedInvoice}
        onOpenChange={(open) => {
          if (!open) pageState.setSelectedInvoice(null);
        }}
      />
    </div>
  );
}
